import { BrowserRouter, Route, Routes } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';

import { Models, Academy, ColorPalettes, Fonts, Home, HowItWorks, InteriorDesign, Stickers } from './pages';
import './index.css';
import { Layout } from './components';

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || '');

const App = () => (
  <div className='app'>
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='academy' element={<Academy />} />
          <Route path='color-palettes' element={<ColorPalettes />} />
          <Route path='3d-models' element={<Models />} />
          <Route path='fonts' element={<Fonts />} />
          <Route path='how-it-works' element={<HowItWorks />} />
          <Route path='interior-design' element={<InteriorDesign />} />
          <Route path='stickers' element={<Stickers />} />

          <Route path='/redirect-google' element={<Home />} />
          <Route path='academy/redirect-google' element={<Academy />} />
          <Route path='color-palettes/redirect-google' element={<ColorPalettes />} />
          <Route path='3d-models/redirect-google' element={<Models />} />
          <Route path='fonts/redirect-google' element={<Fonts />} />
          <Route path='how-it-works/redirect-google' element={<HowItWorks />} />
          <Route path='interior-design/redirect-google' element={<InteriorDesign />} />
          <Route path='stickers/redirect-google' element={<Stickers />} />
          <Route path='/redirect-apple' element={<Home />} />

          <Route path='academy/redirect-apple' element={<Academy />} />
          <Route path='color-palettes/redirect-apple' element={<ColorPalettes />} />
          <Route path='3d-models/redirect-apple' element={<Models />} />
          <Route path='fonts/redirect-apple' element={<Fonts />} />
          <Route path='how-it-works/redirect-apple' element={<HowItWorks />} />
          <Route path='interior-design/redirect-apple' element={<InteriorDesign />} />
          <Route path='stickers/redirect-apple' element={<Stickers />} />

          <Route path='/subscription-activated' element={<Home />} />
          <Route path='academy/subscription-activated' element={<Academy />} />
          <Route path='color-palettes/subscription-activated' element={<ColorPalettes />} />
          <Route path='3d-models/subscription-activated' element={<Models />} />
          <Route path='fonts/subscription-activated' element={<Fonts />} />
          <Route path='how-it-works/subscription-activated' element={<HowItWorks />} />
          <Route path='interior-design/subscription-activated' element={<InteriorDesign />} />
          <Route path='stickers/subscription-activated' element={<Stickers />} />

          <Route path='/trial-activated' element={<Home />} />
          <Route path='academy/trial-activated' element={<Academy />} />
          <Route path='color-palettes/trial-activated' element={<ColorPalettes />} />
          <Route path='3d-models/trial-activated' element={<Models />} />
          <Route path='fonts/trial-activated' element={<Fonts />} />
          <Route path='how-it-works/trial-activated' element={<HowItWorks />} />
          <Route path='interior-design/trial-activated' element={<InteriorDesign />} />
          <Route path='stickers/trial-activated' element={<Stickers />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  </div>
);

export default App;
